/**
 * Performs an authenticated fetch request using the BFF session cookie.
 *
 * Sends credentials:'include' with no Authorization header. The server reads
 * the session cookie directly; no token is needed in the browser.
 *
 * @param input - The resource that you wish to fetch
 * @param init - Optional fetch configuration
 * @returns A Promise that resolves to a Response object
 */
export async function authenticatedFetch(
  input: RequestInfo | URL,
  init?: RequestInit,
): Promise<Response> {
  const headers = new Headers(init?.headers);

  return fetch(input, {
    ...init,
    credentials: 'include',
    headers,
  });
}

export default authenticatedFetch;
